import { MeClient, LabelClient, UserCodeClient, AttachmentClient, AfschotmeldingClient, ReferentieDataClient, OpmerkingClient } from './proxy';

export const Clients = [MeClient, LabelClient, UserCodeClient, AttachmentClient, AfschotmeldingClient, ReferentieDataClient, OpmerkingClient];
